// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.modal-dialog {
  max-width: 1200px !important;
}

#striped-light .card {
  /*margin:0;*/
}

.btn-outline-info:focus {
  color: #ffffff;
}
.btn-outline-info:focus:hover {
  color: #278ed8;
}

.isMapped {
  background-color: limegreen;
}

.isNotMapped {
  background-color: #ffffff;
}

.table thead th {
  background: transparent;
  color: #586562;
}

.mf_hospitallist {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  float: left;
}
.mf_hospitallist li {
  float: left;
  margin: 0 30px 10px 0;
  padding-right: 25px;
  position: relative;
  color: #586562;
}
.mf_hospitallist li .mfActionIcons {
  position: absolute;
  right: 0;
  top: 0;
}

.mapFieldsTableData table {
  border-collapse: collapse;
  width: 100%;
}
.mapFieldsTableData table thead, .mapFieldsTableData table tbody, .mapFieldsTableData table tr, .mapFieldsTableData table td, .mapFieldsTableData table th {
  display: block;
}
.mapFieldsTableData table thead tr th {
  float: left;
  /*padding-left: 0;*/
}
.mapFieldsTableData table tbody {
  height: 400px;
  overflow-y: auto;
  width: 100%;
}
.mapFieldsTableData table tbody tr {
  clear: left;
  border-bottom: 1px solid #dee2e6;
}
.mapFieldsTableData table tbody tr td {
  float: left;
  border: none;
  background: transparent;
  /*&.mfSampleentry {
  	.ng-star-inserted {
  		float: left;
  		margin-right: 20px;
  	}
  }*/
}
.mapFieldsTableData table tbody tr td.mfSampleentry {
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  padding: 0;
}
.mapFieldsTableData table tbody tr td.mfSampleentry .ng-star-inserted {
  border-bottom: 1px solid #dee2e6;
  padding: 5px 10px;
}
.mapFieldsTableData table tbody tr td.mfSampleentry .ng-star-inserted:last-child {
  border-bottom: none;
}
.mapFieldsTableData table tbody tr.isMapped {
  width: 100%;
  float: left;
  background: #b6ffb6;
}

/* end mapFieldsTableData */`, "",{"version":3,"sources":["webpack://./src/app/uploadfile/modals/maputility.screen.component.scss"],"names":[],"mappings":"AACA;EACC,4BAAA;AAAD;;AAGC;EACC,YAAA;AAAF;;AAIA;EACC,cAAA;AADD;AAEC;EACC,cAAA;AAAF;;AAIA;EACC,2BAAA;AADD;;AAGA;EACC,yBAAA;AAAD;;AAKE;EACC,uBAAA;EACA,cAAA;AAFH;;AAQA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AALD;AAOC;EACC,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AALF;AAOE;EACC,kBAAA;EACA,QAAA;EACA,MAAA;AALH;;AAYC;EACC,yBAAA;EACA,WAAA;AATF;AAWE;EACC,cAAA;AATH;AAcI;EACC,WAAA;EACA,mBAAA;AAZL;AAiBE;EACC,aAAA;EACA,gBAAA;EACA,WAAA;AAfH;AAiBG;EACC,WAAA;EACA,gCAAA;AAfJ;AAiBI;EACC,WAAA;EACA,YAAA;EACA,uBAAA;EAiBA;;;;;IAAA;AA1BL;AAWK;EACC,8BAAA;EACA,+BAAA;EACA,UAAA;AATN;AAWM;EACC,gCAAA;EACA,iBAAA;AATP;AAWO;EACC,mBAAA;AATR;AAsBI;EACC,WAAA;EACA,WAAA;EACA,mBAAA;AApBL;;AAyBG,2BAAA","sourcesContent":["\ndiv.modal-dialog  {\n\tmax-width:1200px !important;\n}\n#striped-light {\n\t.card {\n\t\t/*margin:0;*/\n\t}\n}\n\n.btn-outline-info:focus {\n\tcolor: #ffffff ;\n\t&:hover {\n\t\tcolor: #278ed8 ;\n\t}\n}\n\n.isMapped{\n\tbackground-color: limegreen;\n}\n.isNotMapped {\n\tbackground-color: #ffffff;\n}\n\n.table {\n\tthead {\n\t\tth {\n\t\t\tbackground: transparent;\n\t\t\tcolor: #586562;\n\t\t}\n\t}\n}\n\n\n.mf_hospitallist {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\twidth:100%;\n\tfloat: left;\n\n\tli {\t\n\t\tfloat: left;\n\t\tmargin: 0 30px 10px 0;\n\t\tpadding-right: 25px;\n\t\tposition: relative;\n\t\tcolor: #586562;\n\n\t\t.mfActionIcons {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 0;\n\t\t}\n\t}\n}\n\n\n.mapFieldsTableData {\n\ttable  {\n\t\tborder-collapse: collapse; \n\t\twidth: 100%;\n\n\t\tthead,tbody,tr,td,th{\n\t\t\tdisplay:block;\n\t\t}\n\n\t\tthead {\n\t\t\ttr {\n\t\t\t\tth {\n\t\t\t\t\tfloat:left;\n\t\t\t\t\t/*padding-left: 0;*/\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\theight:400px;\n\t\t\toverflow-y:auto;\n\t\t\twidth: 100%;\n\t\t\t\n\t\t\ttr {\n\t\t\t\tclear: left;\n\t\t\t\tborder-bottom: 1px solid #dee2e6;\n\t\t\t\t\n\t\t\t\ttd {\n\t\t\t\t\tfloat:left;\n\t\t\t\t\tborder:none;\n\t\t\t\t\tbackground: transparent;\n\n\t\t\t\t\t&.mfSampleentry {\n\t\t\t\t\t\tborder-left: 1px solid #dee2e6;\n\t\t\t\t\t\tborder-right: 1px solid #dee2e6;\n\t\t\t\t\t\tpadding: 0;\n\n\t\t\t\t\t\t.ng-star-inserted {\n\t\t\t\t\t\t\tborder-bottom: 1px solid #dee2e6;\n\t\t\t\t\t\t\tpadding: 5px 10px;\n\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t/*&.mfSampleentry {\n\t\t\t\t\t\t.ng-star-inserted {\n\t\t\t\t\t\t\tfloat: left;\n\t\t\t\t\t\t\tmargin-right: 20px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}*/\n\t\t\t\t}\n\n\t\t\t\t&.isMapped {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tfloat: left;\n\t\t\t\t\tbackground: #b6ffb6;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}  /* end mapFieldsTableData */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
